import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import saveAs from 'file-saver';
import { jsPDF } from 'jspdf';
import { setVerifyInputFile, setVerifyDSInputFile, clearVerifyInputFile,
		clearVerifyDSInputFile, clearVerifyResultData, clearFileSignedData, setVerifyDSExpand, clearModifiedDSData, setIsLoading, setSignatureDifferenceType,
		clearSignatureDifferenceType, setShowPreviewPopupVerify, setBodyIsMounted, setShowUpgradeCard } from '../../actions/localStates'

import { checkExtensionVerify, fromBytes } from '../../actions/stringEncodersFuncs'
import { bindActionCreators } from 'redux'
import i18next from 'i18next'

import '../../fonts/Roboto-Regular-normal.js';
import '../../fonts/Roboto-Regular-bold.js';
import '../../fonts/Roboto-Bold-normal.js';

import '../../fonts/Hauora-ExtraBold-bold.js';
import '../../fonts/Hauora-ExtraBold-normal.js';
import '../../fonts/Hauora-Regular-normal.js';
import '../../fonts/KharkivTone04_10_2020-normal.js';

// import html2pdf from 'html2pdf.js';

import VerifyDSOptionsContainer from '../../containers/VerifyDSOptionsContainer'
import VerifyTextDSContainer from '../../containers/VerifyTextDSContainer'

import PreviewPopup from '../../containers/PreviewPopup'

import QRPopup from './QRPopup'
import PrivateSignPopup from './PrivateSignPopup'

import Dropzone from 'react-dropzone';

const dropzoneRef = createRef();
const dropzoneDSRef = createRef();

function normalizeOid(oid) {
  const baseOids = [
    "1.2.804.2.1.1.1.1.3.6",
  	"1.2.804.2.1.1.1.1.3.1"
  ];

  for (const base of baseOids) {
    if (oid === base || oid.startsWith(base + ".")) {
      return base;
    }
  }

  return oid;
}

class VerifyDSTab extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	isLoading: false,
	    	collapseVerifyDSShow: "",
	    	showPopup: false,
	    	displayedData: null,
	    	showPrivateSignPopup: false
	    }

	    this.showDsVerifyResults = this.showDsVerifyResults.bind(this);
	    this.handleShowQR = this.handleShowQR.bind(this);

	    this.handleOnDrop = this.handleOnDrop.bind(this);
	    this.handleOnDropDS = this.handleOnDropDS.bind(this);

	    this.copyVerifyResults = this.copyVerifyResults.bind(this);
	    this.generateTextResult = this.generateTextResult.bind(this);

	    this.saveVerifyResultsToPdf = this.saveVerifyResultsToPdf.bind(this);

	    this.showPreviewPopupVerify = this.showPreviewPopupVerify.bind(this);
	    this.handleShowPrivateSign = this.handleShowPrivateSign.bind(this);
	}

	handleShowPrivateSign (base64Image) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				privateSignImage: base64Image
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPrivateSignPopup: !this.state.showPrivateSignPopup
        });
    }

	handleShowQR (i) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				qrLink: this.props.defaultState.verifyResultsForQR[i]
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPopup: !this.state.showPopup
        });
    }

	expandVerifyDS() {
		this.props.actions.setVerifyDSExpand(this.props.expandedCardsReducer.verifyExpanded)
		this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse"}) : this.setState({collapseVerifyDSShow: "card-body collapse show"})
	}

	buildFileInputSelector(){
		const fileInputSelector = document.getElementById('fileInputUpload');
		return fileInputSelector;
	}

	buildFileWithDSSelector(){
		const fileWithDSSelector = document.getElementById('fileWithDSUpload');
		return fileWithDSSelector;
	}

	componentDidMount(){
    	var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

    	this.fileInputSelector = this.buildFileInputSelector();
    	this.fileWithDSSelector = this.buildFileWithDSSelector();
    	this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse show"}) : this.setState({collapseVerifyDSShow: "card-body collapse"})

    	if (dropFile !== null) {
			dropFile.addEventListener('dragenter', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragover', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragleave', function(event) {
				dropFile.style.border = "";
			}, false);
		}

		if (dropDS !== null) {
			dropDS.addEventListener('dragenter', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragover', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragleave', function(event) {
				dropDS.style.border = "";
			}, false);
		}

		this.props.actions.setBodyIsMounted(true);
	}

	componentDidUpdate(prevProps) {
		var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

		if (prevProps.signatureType !== this.props.defaultOptionState.signatureType) {
			this.fileInputSelector = this.buildFileInputSelector();
		}

		if (this.state.isLoading && (this.props.defaultState.verifyResults || this.props.defaultState.verifyResults === undefined)) {
			this.setState({isLoading: false})
		}

		if (prevProps.fileInputSelected !== this.props.defaultState.fileInputSelected) {
			if (dropFile !== null) {
				dropFile.addEventListener('dragenter', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragover', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragleave', function(event) {
					dropFile.style.border = "";
				}, false);
			}
		}

		if (prevProps.fileWithDSSelected !== this.props.defaultState.fileWithDSSelected) {
			if (dropDS !== null) {
				dropDS.addEventListener('dragenter', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragover', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragleave', function(event) {
					dropDS.style.border = "";
				}, false);
			}
		}
	}

	handleFileInputSelect(e) {
		e.preventDefault();
		this.fileInputSelector.value = null;
	    this.fileInputSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	handleFileWithDSSelect(e) {
	    e.preventDefault();
	    this.fileWithDSSelector.value = null;
	    this.fileWithDSSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	onChangeInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(e.target.files[0])
		}
	}

	handleOnDrop (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(files[0])
		}
	}

	onChangeDS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(e.target.files[0])
		}
	}

	handleOnDropDS (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(files[0])
		}
	}

	setInputState() {
		this.props.actions.clearVerifyResultData()
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	cleanUpFileInputSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyInputFile()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearModifiedDSData()
	}

	cleanUpFileWithDSSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyDSInputFile()
		this.props.actions.clearModifiedDSData()
		this.props.actions.clearFileSignedData()
	}

	downloadModifiedData() {
		if (this.props.defaultState.fileInputName.length > 0) {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileInputName + ".p7s")
		} else {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileWithDSName)
		}
	}

	verifyModifiedData () {
		var fileName;

		if (this.props.defaultState.fileInputName.length > 0) {
			fileName = this.props.defaultState.fileInputName + ".p7s"
		} else {
			fileName = this.props.defaultState.fileWithDSName
		}
    	saveAs(this.props.upgradeReducer.modifiedDSData, fileName)

		function blobToFile(blob, fileName, mimeType = blob.type) {
		    return new File([blob], fileName, { type: mimeType });
		}

		const blob = new Blob([this.props.upgradeReducer.modifiedDSData], { type: "application/pkcs7-signature" });
		const file = blobToFile(blob, fileName);

		this.props.actions.setShowUpgradeCard(false)
		this.props.actions.setVerifyDSInputFile(file)
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	downloadSignedData() {
		function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

        // var dataFileName = removeExtraExtensions(name)
        var dataFileName = removeTrailingP7sExtensions(this.props.defaultState.fileWithDSName)

    	saveAs(this.props.defaultState.fileSignedData, dataFileName)
	}

	cleanUpForm(){
		this.cleanUpFileInputSelect()
		this.cleanUpFileWithDSSelect()
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearSignatureDifferenceType()
	}

	generateTextResult() {
		var strList = "", str = "", isValid;

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		this.props.defaultState.verifyResults
        .sort((first, second) => {
            const firstHash = highestPriorityDate(first);
            const secondHash = highestPriorityDate(second);

            if (firstHash < secondHash) {
                return -1;
            }

            if (firstHash > secondHash) {
                return 1;
            }

            return 0;
        })
        .map(highestPriorityDate)

		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

		    str += (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {
				str += i18next.t("ds:signer") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value + "\n"

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
					str += i18next.t("ds:organizationName") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
					str += i18next.t("ds:title") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
					str += i18next.t("ds:drfou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
					str += i18next.t("ds:edrpou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value + "\n"
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
		        	str += i18next.t("ds:eddrun") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value + "\n"
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		str += i18next.t("certificateSerialNumberTitle") + this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		str += i18next.t("ds:ca") + this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0) {
		       		str += i18next.t("ds:dsDate") + this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime) + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].contentTimestamp, "content")
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].signatureTimestamps[j], "signature")
					}
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value.length > 0) {
					var isElectronicStampTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:isElectronicStampTitle") + isElectronicStampTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value.length > 0) {
					var qualifiedCertTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value.length > 0) {
					var QSCDTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName) {
					var QSCDTypeTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value
					str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureType) {
					var signatureType = this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureType
					str += i18next.t("ds:signatureType") + signatureType + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat) {
					var signatureFormat = this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureFormat
					str += i18next.t("ds:signatureFormat") + signatureFormat + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureAlgorithmOid) {
					str += i18next.t("signatureAlgorithmOid") + i18next.t("ds:" + normalizeOid(this.props.defaultState.verifyResults[i].signatureAlgorithmOid)) + "\n"
		        }

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
					str += i18next.t("ds:lawMsgFirstRow") + "\n"
					str += i18next.t("ds:lawMsgSecondRow") + "\n"
					str += i18next.t("ds:lawMsgThirdRow") + "\n"
				}

				// if (this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
				// 	str += this.props.defaultState.verifyResults[i].failureCause
				// }
			} else {
				str += this.props.defaultState.verifyResults[i].failureCause
			}

			strList += str + "\n";
		}

		return strList;
	}

	copyVerifyResults() {
		var textArea,
        copy;

	    function isOS() {
	        return navigator.userAgent.match(/ipad|iphone/i);
	    }

	    function createTextArea(text) {
	        textArea = document.createElement('textArea');
	        textArea.value = text;
	        textArea.style.cssText = "position: absolute";
	        textArea.style.cssText = "top: -9999px";
	        document.body.appendChild(textArea);
	    }

	    function selectText() {
	        var range,
	            selection;

	        if (isOS()) {
	            range = document.createRange();
	            range.selectNodeContents(textArea);
	            selection = window.getSelection();
	            selection.removeAllRanges();
	            selection.addRange(range);
	            textArea.setSelectionRange(0, 999999);
	        } else {
	            textArea.select();
	        }
	    }

	    function copyToClipboard() {        
	        document.execCommand('copy');
	        document.body.removeChild(textArea);
	    }

	    copy = function(text) {
	        createTextArea(text);
	        selectText();
	        copyToClipboard();
	        document.getElementById("copyLink").style.color = "green";
	        window.setTimeout(function () {
	        	document.getElementById("copyLink").style.color = "#1a0dab";
	        }, 1500)
		};

		copy(this.generateTextResult());
	}

	saveVerifyResultsToPdf () {
		var isValid, doc = new jsPDF(), dateNow = new Date(), verticalOffset = 65, wrappedText, needSort = true, cleaned = "", archTimestampCounter = 0, dataFileName = "", tempOffset = 0, tempOffsetSecond = 0, maxWidth = 120, failureCauseSplited;
		var img = 'data:image/jpeg;base64,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'

		this.props.defaultState.verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				return;
			}
		})

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		if (needSort) {
			this.props.defaultState.verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

		function footer(){ 
			doc.setFont("Hauora-Regular", 'normal');
   			doc.setFontSize(10);
		    doc.text(198,292, doc.page.toString());
		    doc.page += 1;
		};

		doc.page = 1;

		footer()
		
		doc.addImage(img, 'PNG', 10, 10, 65, 16)
		doc.setFont('Hauora-Regular', 'normal');
		doc.setFontSize(8);

		doc.setTextColor("black");

		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.text(i18next.t("titlePdf"), 90, 15);
   		doc.text(i18next.t("addresTitlePdf"), 90, 19);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("streetAdddresPdf"), 102, 19);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.text("E-mail:", 90, 23);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text("ca@novapay.ua", 100, 23);

   		doc.line(10, 30, 200, 30);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.setFontSize(18);
   		doc.setTextColor("black");
   		doc.text(i18next.t("clientTitlePdf"), 105, 40, {align:'center'});

   		doc.text(i18next.t("protocolTitlePdf"), 105, 48, {align:'center'});

   		doc.setFontSize(10);
   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("verifyTitlePdf"), 105, 53, {align:'center'});

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("dateTimePdf"), 10, 60);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(dateNow.toLocaleString(), this.props.localesReducer.language === "en" ? 36 : 32, 60);


   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileNameWithDS"), 10, 66);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);

   		maxWidth = 120;

		wrappedText = doc.splitTextToSize(this.props.defaultState.fileWithDS.name, maxWidth);
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 42 : 55, 66);

		if (wrappedText.length > 1) {
			tempOffset = 5;
		}

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithDS"), 10, 70 + tempOffset);

   		var res, str = "";
		res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
		str = res.value + " " + i18next.t(res.unit);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 38 : 56, 70 + tempOffset);

   		var name = this.props.defaultState.fileWithDS.name.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDS.name : this.props.defaultState.fileWithDS.name.substr(0, this.props.defaultState.fileWithDS.name.lastIndexOf("."));

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileNameWithoutDS"), 10, 74 + tempOffset);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);

   		function hasSingleExtension(filename) {
		    const parts = filename.split(".");

		    return parts.length === 2;
		}

		function removeExtraExtensions(filename) {
            return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$0');
        }

        function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

		function hasAsicExtension(filename) {
		  const ext = filename.split('.').pop().toLowerCase();
		  return ext === 'asics' || ext === 'asice';
		}

		if (this.props.defaultOptionState.signatureType === "detached") {
			dataFileName = this.props.defaultState.fileInput.name
		} else {
			cleaned = removeTrailingP7sExtensions(this.props.defaultState.fileWithDS.name);
			dataFileName = cleaned
		}

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			dataFileName = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			dataFileName = "-"
		}

		maxWidth = 140;

		wrappedText = doc.splitTextToSize(dataFileName, maxWidth);

		if (wrappedText.length > 1) {
			tempOffsetSecond = 5;
		}
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 45 : 56, 74 + tempOffset);

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithoutDS"), 10, 78 + tempOffset + tempOffsetSecond);

   		if (this.props.defaultState.fileSignedData === null) {
   			if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
   				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
   			} else {
   			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
   			}
   		} else {
   			res = this.props.actions.fromBytes(this.props.defaultState.fileSignedData.size);
   		}

		str = res.value + " " + i18next.t(res.unit);

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			str = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			str = "-"
		}

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 43 : 58, 78 + tempOffset + tempOffsetSecond);


   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("verifyResultsTitlePdf"), 10, 85);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("verifySuccessPdf"), this.props.localesReducer.language === "en" ? 61 : 64, 85);
   		// doc.text("Цілісність даних підтверджено.", 10, 69);

   		doc.setFontSize(10);
   		// doc.text(10, 78, str);

   		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			// isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			// str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

			if (this.props.defaultState.verifyResults[i].isUntrustedValid) {
				failureCauseSplited = this.props.defaultState.verifyResults[i].failureCause.split('\n')
			}

			if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
   				archTimestampCounter += 1;
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
   			} else {
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
   			}

			if (verticalOffset + 90 > 290) {
				verticalOffset = 10;
				doc.addPage();
				footer()
				doc.setFont('Hauora-Regular', 'normal');

		   		doc.setFontSize(10);
			}

			if (i === 0) {
				verticalOffset = verticalOffset + 32
			} else {
				verticalOffset = verticalOffset + 8
			}
			

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("red");

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					}

					if (!needSort) {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 50 : 43, verticalOffset);
						}
					} else {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					}

				} else {

					if (this.props.defaultState.verifyResults[i].isValid) {
						doc.setTextColor("green");
					} else {
						doc.setTextColor("red");
					}

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					}

					if (!needSort) {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 50 : 43, verticalOffset);
						}
						
					} else {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					}
					
				}

				// if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
				// 	doc.setFont("Hauora-ExtraBold", 'normal');
				// 	doc.setTextColor("red");
				// 	doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
				// 	doc.text(isValid, 27, verticalOffset);
				// } else {
				// 	doc.setFont("Hauora-ExtraBold", 'normal');

				// 	if (this.props.defaultState.verifyResults[i].isValid) {
				// 		doc.setTextColor("green");
				// 	} else {
				// 		doc.setTextColor("red");
				// 	}
					
				// 	doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
				// 	doc.text(isValid, 27, verticalOffset);
				// }

				verticalOffset = verticalOffset + 5;
				doc.setFont("Hauora-ExtraBold", 'normal');
				doc.setTextColor("black");

				var isQualified
				if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:unqualifiedTitleShe")
				} else {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				}
				// var isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				// doc.text(i18next.t("dsType") + isQualified, 10, verticalOffset);
				doc.text(isQualified, 10, verticalOffset);

				// verticalOffset = verticalOffset + 5;
				// doc.setFont("Hauora-ExtraBold", 'normal');
				// doc.setTextColor("black");
				// var isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				// doc.text(isQualified, 10, verticalOffset);

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:signer"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value, this.props.localesReducer.language === "en" ? 24 : 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:organizationName"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 160);
					doc.text([...wrappedText], this.props.localesReducer.language === "en" ? 35 : 33, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:title"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 160);
					doc.text([...wrappedText], 27, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 27, verticalOffset);
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:drfou"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value, this.props.localesReducer.language === "en" ? 25 : 27, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:edrpou"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value, 27, verticalOffset);
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		        	verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:eddrun"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value, 27, verticalOffset);
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("certificateSerialNumberTitle"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, ""), this.props.localesReducer.language === "en" ? 74 : 85, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:ca"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value, this.props.localesReducer.language === "en" ? 20 : 35, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		       		if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
			       		verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("red");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 38 : 34, verticalOffset);

						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("red");
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
							doc.text(i18next.t("dsTs") + ": ", 10, verticalOffset);
							doc.setFont("Hauora-Regular", 'normal');
							doc.text("Відсутня", 70, verticalOffset);
						}
						
					} else {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 38 : 34, verticalOffset);
					}
		       	}

		       	if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length > 0 && this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		verticalOffset = verticalOffset + 5;

					if (this.props.defaultState.verifyResults[i].contentTimestamp && this.props.defaultState.verifyResults[i].contentTimestamp.dateTime) {
			            if (this.props.defaultState.verifyResults[i].contentTimestamp.isFailure) {
			            	doc.setFont("Hauora-ExtraBold", 'normal');
			            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
			            	doc.setFont("Hauora-Regular", 'normal');
			            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
			            } else {
			            	isValid = this.props.defaultState.verifyResults[i].contentTimestamp.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

			            	doc.setFont("Hauora-ExtraBold", 'normal');
			            	doc.setTextColor("green");
			            	doc.text(i18next.t("dataTs") + ": " + isValid + "; ", 10, verticalOffset);
			            	doc.setFont("Hauora-Regular", 'normal');
			            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].contentTimestamp.dateTime), this.props.localesReducer.language === "en" ? 60 : 85, verticalOffset);

			            	if (this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber) {
			            		verticalOffset = verticalOffset + 5;
			            		doc.setTextColor("black");
			            		doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.text(i18next.t("tsaCertificateSerialNumber"), 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 82 : 125, verticalOffset);
			            	}
			            }
			        }
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime) {
							verticalOffset = verticalOffset + 5;
				            if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].isFailure) {
				            	doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
				            } else {
				            	isValid = this.props.defaultState.verifyResults[i].signatureTimestamps[j].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

				            	doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.setTextColor("green");
				            	doc.text(i18next.t("dsTs") + ": " + isValid + "; ", 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime), this.props.localesReducer.language === "en" ? 69 : 88, verticalOffset);

				            	if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber) {
				            		verticalOffset = verticalOffset + 5;
				            		doc.setTextColor("black");
				            		doc.setFont("Hauora-ExtraBold", 'normal');
					            	doc.text(i18next.t("tsaCertificateSerialNumberDS"), 10, verticalOffset);
					            	doc.setFont("Hauora-Regular", 'normal');
					            	doc.text(this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 98 : 119, verticalOffset);
				            	}
				            }
				        }

					}
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:isElectronicStampTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 41 : 48, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:qualifiedCertTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 47 : 61, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 23 : 29, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTypeTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value, this.props.localesReducer.language === "en" ? 31 : 39, verticalOffset);
				}

            	if (this.props.defaultState.verifyResults[i].signatureType && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:signatureType"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureType), this.props.localesReducer.language === "en" ? 38 : 41, verticalOffset);
            	}

            	if (this.props.defaultState.verifyResults[i].signatureFormat) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:signatureFormat"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');

					if (this.props.defaultState.verifyResults[i].signatureFormat !== null && this.props.defaultState.verifyResults[i].signatureFormat === "CADES_T" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false")
					{
                		doc.text(i18next.t("ds:CADES_TU"), 38, verticalOffset);
                	} else {
                		doc.text(this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureFormat), this.props.localesReducer.language === "en" ? 42 : 41, verticalOffset);
                	}
	            	
            	}

            	if (this.props.defaultState.verifyResults[i].signatureAlgorithmOid) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("signatureAlgorithmOid"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	var normilizedOid = "ds:" + normalizeOid(this.props.defaultState.verifyResults[i].signatureAlgorithmOid)
	            	doc.text(i18next.t(normilizedOid), this.props.localesReducer.language === "en" ? 47 : 44, verticalOffset)
		        }

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFirstRow"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSecondRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgThirdRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFourthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFifthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSixthRowPDF"), 10, verticalOffset);
				}

			} else {
				doc.setFont("Hauora-ExtraBold", 'normal');
				doc.setTextColor("red");
				doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
				doc.text(i18next.t("ds:notDefined"), 28, verticalOffset);

				var splitText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].failureCause, 180);
				doc.setFont("Hauora-Regular", 'normal');
				doc.setTextColor("black");

				verticalOffset = verticalOffset + 5;

				for (var c = 0; c < splitText.length; c += 1){
			        doc.text(10, verticalOffset, splitText[c]);
			        verticalOffset = verticalOffset + 5;
			    }
			}
		}

		verticalOffset = verticalOffset + 10;
		doc.setFont("Hauora-Regular", 'normal');
		doc.setTextColor("black");
		doc.text(i18next.t("verifyAddressPdf"), 10, verticalOffset);
		doc.setTextColor("blue");
		doc.textWithLink("https://caas.novapay.ua/", 10, verticalOffset + 5, {url: 'https://caas.novapay.ua/'});

   		// doc.output("dataurlnewwindow");
   		var fileName
   		if (this.props.defaultState.fileInputName.length > 0) {
   			fileName = this.props.defaultState.fileInputName.substring(0, this.props.defaultState.fileInputName.indexOf('.')) || this.props.defaultState.fileInputName;
			doc.save(fileName + "-validation-report.pdf")
		} else {
			fileName = this.props.defaultState.fileWithDSName.substring(0, this.props.defaultState.fileWithDSName.indexOf('.')) || this.props.defaultState.fileWithDSName;
			doc.save(fileName + "-validation-report.pdf")
		}
	}

	formatDate(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZoneName": "short"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

    constructTimestampDetails(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result.push(<div>{tsTypeString() + i18next.t("ds:errorWhileVerifying")}</div>);
            } else {
            	result.push(
	            	<div>
	            		<div>
	            			<span className="font-weight-bold">{tsTypeString()}</span>
	            			{
			            		": "
			                    + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid"))
			                    + "; "
			                    + this.formatDate(aTs.dateTime)
		                	}
		                	{
		                		aTs.tsaCertificateSerialNumber
		                		? <div><span className="font-weight-bold">{tsaTsTypeString()}</span>
				                	{
					                    aTs.tsaCertificateSerialNumber
				                	}
				                </div>
				                : null
		                	}	                	
	            		</div>
	                </div>
                );
            }
        }
        return result;
    }

    constructTimestampDetailsText(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result = tsTypeString() + ": " + i18next.t("ds:errorWhileVerifying") + "\n";
            } else {
            	var isValid = aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
            	result = tsTypeString() + ": " + isValid + "; " + this.formatDate(aTs.dateTime) + "\n"

            	if (aTs.tsaCertificateSerialNumber) {
            		result += tsaTsTypeString() + aTs.tsaCertificateSerialNumber + "\n"
            	}
            }
        }
        return result;
    }

	showDsVerifyResults(verifyResults, elementToDisplay, resultType) {
		let rootDiv = [], divPtblg = [], diffType = [], _this = this, needSort = true, isNested = false, archTimestampCounter = 0, failureCauseSplited;
		var generateVerifyResultsViewSimple = generateVerifyResultsViewSimple.bind(this);

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];


		verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				isNested = true;
				return;
			}
		})

		if (needSort) {
			verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

        if (this.props.defaultOptionState.showUpgradeCard) {
        	verifyResults.forEach(function (element) {
	        	_this.props.defaultState.differenceSignatureType.forEach(function (secondElement) {
	        		if (element.signerInfo.certificateSerialNumber !== undefined) {
	        			if (element.signerInfo.certificateSerialNumber.value === secondElement.signerInfo.certificateSerialNumber.value) {
		        			diffType.push(secondElement)
		        		}
	        		}
	        	})
	        })
        }

        function generateVerifyResultsViewSimple (verifyResults) {
        	for (var i = 0; i < verifyResults.length; i += 1) {
	        	let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];
				let tsDetails = [];
				let tempString = [];

				if (verifyResults[i].isUntrustedValid) {
					failureCauseSplited = verifyResults[i].failureCause.split('\n')
				}

				if (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					archTimestampCounter += 1;
				}

				if (verifyResults[i].signatureTimestamps && verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < verifyResults[i].signatureTimestamps.length; j += 1) {
						tsDetails.push(this.constructTimestampDetails(verifyResults[i].signatureTimestamps[j], "signature"))
					}
				} else {
					if (!this.props.defaultOptionState.showUpgradeCard && (Object.keys(verifyResults[i].contentTimestamp).length === 0) && (verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
						tempString.push(<div style={{fontSize: "14px", color: "red"}}>
							<hr style={{marginBottom: "0px", marginTop: "5px"}} />
							<span><p>{i18next.t("ds:lawMsgFirstRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgSecondRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgThirdRow")}</p></span>
						</div>);
					}			
				}

				

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        	{	
		        		verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		    			? i18next.t("ds:ARCHIVE_TIMESTAMP")
		    			: i18next.t("ds:signature") + ((i + 1) - archTimestampCounter)
		        	}
	        	</div>)

	        	if (verifyResults[i].status === "SUCCESS") {
	        		if (resultType === "verifyResults") {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		{
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <span style={{color: "red"}}>{verifyResults[i].failureCause}</span>
			        			: null
			        		}
		        		</div>)
	        		} else {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		
		        		</div>)
	        		}
			        
			        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
		    			<div>
		    				{
		    					verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP"
		    					? <div><span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span></div>
		    					: null
		    				}
		    			</div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
					        		</div> : null
					        } {

								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
					        		</div> : null
					        } {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
						        	<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
					        		</div> : null
					        }
		    			<div>
		    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
		        		</div>
		        		 	{
					        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
					        		</div> : null
		                    }
		    			<div>
		    				{
		    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
		    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(verifyResults[i].signingDateTime)}</span></span>
		    					: null
		    				}
		    			</div>
		    			<div>
		    				{
		    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
		    				}
		    			</div>
		    			<div>
		    				{
		    					tsDetails
			                }
		    			</div>
		    			<div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureFormat ?
			                        <div>
			                        	{
			                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
			                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
			                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
			                        	}
					    				
					        		</div> : null
					        }
					        {
					        	verifyResults[i].signatureAlgorithmOid
								? <div>
					    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(verifyResults[i].signatureAlgorithmOid))}</span>
					        		</div>
								: null

					        }
					        {
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <div style={{marginTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
			        			: null
			        		}

			        		{
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:pspId") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspId.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ncaId") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaId.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ncaName") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:pspRoles") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspRoles.value}</span>
					        		</div> : null
					        }
		    			</div>
		    		</div>)

		        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
		        		{	
		        			this.props.defaultOptionState.showUpgradeCard && (diffType[i].previousSignatureFormat === "CADES_X_LONG" ? true : false)
				    		? <div className="alert alert-warning">
				        		{i18next.t("ds:alreadyModifiedTitle")}
				        	</div>
				        	: null
		        		}
		        		{
							 <div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}{(verifyResults[i].signatureImageData !== null && verifyResults[i].signatureImageData !== undefined && verifyResults[i].signatureImageData.length > 0 && this.props.base.padesEnabled === "true") ? <div style={{paddingRight: "15px"}}><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>{i18next.t("hwsImageLabel")}</label><img style={{maxWidth: "100%", maxHeight: "100%", cursor: "pointer"}} src={"data:image/png;base64," + verifyResults[i].signatureImageData} onClick={this.handleShowPrivateSign.bind(this, verifyResults[i].signatureImageData)} alt="" /></div> : null}{this.props.defaultOptionState.generateQR ? <div><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px", paddingTop: "10px"}}>{i18next.t("QRSignLabel")}</label><img src={this.props.defaultState.verifyResultsForQR[i]} onClick={this.handleShowQR.bind(this, i)} style={{width: "100px", height: "100px", cursor: "pointer"}} alt="" /></div> : null}</div><div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        		<div>
					        		{
					        			tempString
					        		}
					        	</div>
				        	</div>
				        }
		        	</div>)
		        } else {
		        	if (verifyResults[i].isUntrustedValid) {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        	</div>)
		        		signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
			    			</div>
			    				{
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
							        	<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
						        		<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
						        		</div> : null
						        }
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
			        		</div>
			        		 	{
						        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
						        		</div> : null
			                    }
			    			<div>
			    				{
			    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
			    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(verifyResults[i].signingDateTime)}</span></span>
			    					: null
			    				}
			    			</div>
			    			<div>
			    				{
			    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
			    				}
			    			</div>
			    			<div>
			    				{
			    					tsDetails
				                }
			    			</div>
			    			<div>
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureType ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureFormat ?
				                        <div>
				                        	{
				                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
				                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
				                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
				                        	}
						    				
						        		</div> : null
						        }
						        {
						        	verifyResults[i].signatureAlgorithmOid
									? <div>
						    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(verifyResults[i].signatureAlgorithmOid))}</span>
						        		</div>
									: null

						        }
						        {
						            verifyResults[i].isUntrustedValid
						            ? <div><p></p>
						            	<div>
						            		{
						            			<p><b>{failureCauseSplited[0]}</b></p>
						            		}
						            		
						            		{/*<p style={{"marginBottom": "0.5rem"}}><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></p>*/}
						            	</div>
						            </div>
						            : null
						        }
			    			</div>
			    		</div>)
						divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	} else {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        		</div>)
				        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
				    			<div>
				    				{ verifyResults[i].failureCause }
				    				{
							            verifyResults[i].isUntrustedValid
							            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
							            : null
							        }
				    			</div>
			    			</div>)
			        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	}
			        
	            }
	        }
        }

		function buildTree(items) {
		  const tree = [];
		  const lastAtLevel = {};

		  items.forEach(item => {
		    const level = item.degreeOfNesting !== undefined
		      ? Number(item.degreeOfNesting)
		      : 0;

		    const node = { ...item, children: [] };

		    if (level === 0) {
		      tree.push(node);
		      lastAtLevel[0] = node;
		    } else {
		      const parent = lastAtLevel[level - 1];
		      if (parent) {
		        parent.children.push(node);
		      } else {
		        console.warn("No parent found for node:", node);
		        tree.push(node); // fallback
		      }
		      lastAtLevel[level] = node;
		    }

		    // очищаємо всі вузли глибше поточного рівня
		    Object.keys(lastAtLevel).forEach(k => {
		      if (Number(k) > level) delete lastAtLevel[k];
		    });
		  });

		  return tree;
		}

		function addIds(items) {
		  return items.map((item, index) => ({
		    ...item,
		    id: index + 1
		  }));
		}

		const updatedData = addIds(verifyResults);

		const tree = buildTree(updatedData);

		const TreeNode = ({ node }) => {
		  return (
		    <div style={styles.parent}>
		      <div>
		          	{
		          		node.status === "SUCCESS"
		        		? <div className={(node.isValid) ? "alert-last alert-success" : "alert-last alert-warning"}>

		        			<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>
				        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
						    			{i18next.t("ds:signature") + node.id}
						        	</div>
			        				
			        				{
				        				resultType === "verifyResults"
				        				? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
							        			{
							        				node.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
							        			}
							        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
								        			{
								        				(node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
								        			}
								        		</div>
								        		{
								        			node.failureCause !== null && node.failureCause !== undefined && node.failureCause.length > 0
								        			? <span style={{color: "red"}}>{node.failureCause}</span>
								        			: null
								        		}
							        		</div>
				        				:   <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
							        			{
							        				node.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
							        			}
							        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
								        			{
								        				(node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
								        			}
								        		</div>
								        		{
								        			node.failureCause !== null && node.failureCause !== undefined && node.failureCause.length > 0
								        			? <span style={{color: "red"}}>{node.failureCause}</span>
								        			: null
								        		}
							        		</div>
				        			}

			        				{this.props.defaultOptionState.generateQR
				        				? <img src={this.props.defaultState.verifyResultsForQR[node.id - 1]} onClick={this.handleShowQR.bind(this, node.id - 1)} style={{width: "100px", height: "100px", marginLeft: "15px", cursor: "pointer"}} alt="" />
				        				: null} 
			        			</div> 
				        			<div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
					    			<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
					    			</div>
					    				{
											node.signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
								        		</div> : null
								        } {
											node.signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
								        		</div> : null
								        } {
											node.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
								        		</div> : null
								        } {
								        	node.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
									        	<div>
								    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ node.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
								        		</div> : null
								        } {
								        	node.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
								        		<div>
								    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ node.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
								        		</div> : null
								        }
					    			<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{node.signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
					        		</div>
					        		 	{
								        	node.signerInfo.certificateSerialNumber.value ? 
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{node.signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
								        		</div> : null
					                    }
					    			<div>
					    				{
					    					node.signingDateTime !== undefined && node.signingDateTime.length > 0
					    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(node.signingDateTime)}</span></span>
					    					: null
					    				}
					    			</div>
					    			<div>
					    				{
					    					this.constructTimestampDetails(node.contentTimestamp, "content")
					    				}
					    			</div>
					    			<div>
					    				{
					    					node.signatureTimestamps.map((element) => (
					    						this.constructTimestampDetails(element, "signature")
					    					))
					    				}
					    				
					    			</div>
					    			<div>
					    				{
											node.signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
					    				{
											node.signerInfo.extensionsCertificateInfo.value.isQualified ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : node.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
								        		</div> : null
								        }
								        {
											node.signatureType ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{node.signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + node.signatureType)}</span>
								        		</div> : null
								        }
								        {
											node.signatureFormat ?
						                        <div>
						                        	{
						                        		node.signatureFormat !== null && node.signatureFormat === "CADES_T" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
						                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
						                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{node.signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + node.signatureFormat)}</span></div>
						                        	}
								    				
								        		</div> : null
								        }
								        {
								        	node.signatureAlgorithmOid
											? <div>
								    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(node.signatureAlgorithmOid))}</span>
								        		</div>
											: null

								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:pspId") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspId.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:ncaId") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaId.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:ncaName") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaName.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:pspRoles") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspRoles.value}</span>
								        		</div> : null
								        }
					    			</div>
					    		</div>
			        			</div>
			        		</div>        			
		        			
		        				
		        		  </div>
		        		: <div>
		        			<div className={(node.isValid) ? "alert-last alert-success" : "alert-last alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
							    			{i18next.t("ds:signature") + node.id}
							        	</div>
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
						        			{i18next.t("ds:notDefined")}
						        		</div>
				        			</div>
				        			<div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
							    			<div>
							    				{ node.failureCause }
							    				{
										            node.isUntrustedValid
										            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
										            : null
										        }
							    			</div>
						    			</div>
				        			</div>
				        		</div>
				        	</div>
		        		</div>
		          	}
		          
		        </div>
		      {node.children.length > 0 && (
		        <div style={styles.children}>
		          {node.children.map((child, index) => (
		          	node.children.length > 1 && ((index + 1) % 2 === 0)
		          	? <div style={{marginTop: "10px"}}><TreeNode key={child.id} node={child} /></div>
		          	: <TreeNode key={child.id} node={child} />
		          ))}
		        </div>
		      )}
		    </div>
		  );
		};

		const TreeView = ({ data }) => {
			console.log("tree", JSON.stringify(tree, null, 2));
		  return (
		    <div style={styles.tree}>
		      {data.map((node, index) => (
		        <TreeNode key={node.id} node={node} />
		      ))}
		    </div>
		  );
		};

		const styles = {
		  tree: {
		    display: "flex",
		    flexDirection: "column",
		    marginBottom: "10px"
		  },
		  parent: {
		    padding: "10px",
		    border: "1px solid rgba(0, 0, 0, 0.125)",
		    borderRadius: "5px"
		  },
		  node: {
		    padding: "10px",
		    border: "1px solid rgba(0, 0, 0, 0.125)",
		    borderRadius: "5px"
		  },
		  children: {
		    marginTop: "10px"
		  }
		};

		function generateModifyResults (verifyResults) {
			for (var i = 0; i < verifyResults.length; i += 1) {
				let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];		

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
	    			{i18next.t("ds:signature") + (i + 1)}
	        	</div>)
	        		
    			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
        			{
        				verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat ? i18next.t("ds:isNotModified") : i18next.t("ds:isModified")
        			}
        		</div>)
		        
		        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
	    			</div>
	    				{
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
					        	<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
				        		<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
				        		</div> : null
				        }
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
	        		</div>

	        		{
	        			verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat
	        			? <div>
							{
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }
	        			</div>
	        			: <div>
		        			{
					        	verifyResults[i].previousSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureFormat) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }

					        {
					        	verifyResults[i].previousSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					    </div>
	        		}
	        		{
	        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
	        			? <div style={{paddingTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
	        			: null
	        		}
	        		
	    		</div>)

	        	divPtblg.push(<div className="ptblg-default" style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
	        		{
						 <div className={(verifyResults[i].status === "SUCCESS") ? "alert alert-success" : "alert alert-warning"}>
			        		<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
			        		</div>
			        	</div>
			        }
	        	</div>)
			}
		}


		if (!this.props.defaultOptionState.showUpgradeCard) {
			if (isNested) {
	        	rootDiv.push(<div id="divPtblg">{
	        		<TreeView data={tree} />
	        	}</div>)
	        } else {
	        	generateVerifyResultsViewSimple(verifyResults)
	        	rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
	        }
		} else {
			generateModifyResults(_this.props.defaultState.differenceSignatureType)
	        rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
		}
          
        return rootDiv

    }

    showPreviewPopupVerify () {
		this.props.actions.setShowPreviewPopupVerify(true);
	}

	render () {
		const isEnabled = this.props.defaultOptionState.signatureType === 'detached' ?
				this.props.defaultState.fileInputSelected && this.props.defaultState.fileWithDSSelected
				: this.props.defaultState.fileWithDSSelected;

		const isEnabledDownload = this.props.defaultState.fileSignedData ? true : false;

		const isPreviewEnabled = this.props.defaultState.fileSignedData && this.props.defaultState.fileWithDSName ? true : false

		const isEnabledDownloadModifiedDS = this.props.upgradeReducer.modifiedDSData ? true : false;

		return (
			<div>
	            <div className="row" style={{paddingTop: "10px"}}>
	            <VerifyDSOptionsContainer />
	              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
	                <div className="card">
	                  <div className="card-header" onClick={this.expandVerifyDS.bind(this)} role="button">
	                    {
							this.props.expandedCardsReducer.verifyExpanded ? <i className="fa fa-chevron-down" aria-hidden="true" style={{"cursor": "pointer"}}></i>
								: <i className="fa fa-chevron-up" aria-hidden="true" style={{"cursor": "pointer"}}></i>
						}&nbsp;{i18next.t("file")}
	                  </div>
	                  <div className={this.state.collapseVerifyDSShow} data-toggle="collapse" aria-expanded={this.props.expandedCardsReducer.verifyExpanded}>
	                    <div>
	                    	{
	                    		this.props.defaultOptionState.signatureType === 'detached'
	                    		? <div className="no-left-right-padding">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileForVerifyingTitle")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                {
		                                  this.props.mobileModeReducer.mobileDeviceMode
		                                  ? 
		                                  <div className="input-group row" style={{marginLeft: "0px"}}>
		                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
		                                    {
												this.props.defaultState.fileInputSelected
												? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("changeFile")}</button>
												: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("chooseFile")}</button>
											}

		                                  </div>
		                                  : <div>
		                                  		{
		                                  			this.props.defaultState.fileInputSelected
		                                  			? <div className="input-group mb-4">
														<input type="text" className="form-control" value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
														<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
								                    : <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
								                        {({getRootProps, getInputProps}) => (
								                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropFile">
								                                <input {...getInputProps()} />
								                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
								                            </div>
								                        )}
								                    </Dropzone>
		                                  		}
											</div>
		                                }
	                                </div>
	                                <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                            </div>
								: <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                    	}

	                    	<div className="no-left-right-padding" style={{marginBottom: "10px"}}>
                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileWithDsTitle")}</label>
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
	                                {
	                                  this.props.mobileModeReducer.mobileDeviceMode
	                                  ? 
	                                  <div className="input-group row" style={{marginLeft: "0px"}}>
	                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
	                                    {
											this.props.defaultState.fileWithDSSelected
											? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("changeFile")}</button>
											: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("chooseFile")}</button>
										}
	                                    </div>
	                                    : <div>
	                                    	{
	                                    		this.props.defaultState.fileWithDSSelected
	                                    		? <div className="input-group mb-4">
													<input type="text" className="form-control" value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
													<div className="input-group-append">
												      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithDSSelect.bind(this)}>{i18next.t("cleanup")}</button>
												    </div>
												</div>
												: <Dropzone ref={dropzoneDSRef} onDrop={this.handleOnDropDS} multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropDS">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
	                                    	}
	                                      </div>
	                                    
	                                }
                                </div>
                                <input id="fileWithDSUpload" type="file" onChange={this.onChangeDS.bind(this)} style={{"display": "none"}} />
                            </div>
                            {
                            	(!this.props.base.isLoading && this.props.defaultState.verifyResults !== null && this.props.defaultState.verifyResults.length > 0 && !this.props.defaultOptionState.showUpgradeCard)
                            	? <div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "left", marginTop: "-10px", marginBottom: "10px"}}>
                            			{
                            				this.props.base.pdfReportEnabled === "true"
                            				? <span style={{cursor: "pointer", color: "#1a0dab", textAlign: "left"}} onClick={this.saveVerifyResultsToPdf}>{i18next.t("inspectionReport")}</span>
                            				: null
                            			}
		                        	</div>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "right", marginTop: "-10px", marginBottom: "10px"}}>
		                            	<span id="copyLink" style={{cursor: "pointer", color: "#1a0dab", textAlign: "right"}} onClick={this.copyVerifyResults}>{i18next.t("copyVerifyDSResultToClipboardTitle")}</span>
		                        	</div>
		                        </div>
                            	: null
                            }

                            {
                            	this.props.defaultOptionState.generateQR
                            	? (!this.props.base.isLoading && this.props.defaultState.verifyResults && this.props.defaultState.verifyResultsForQR) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            	: (!this.props.base.isLoading && this.props.defaultState.verifyResults) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            }

							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-0 order-md-4">
			                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.setInputState.bind(this)} disabled={!isEnabled}>{this.props.defaultOptionState.showUpgradeCard ? i18next.t("ds:modifyDs") : i18next.t("ds:verifyDs")}
			                        	{
			                              	this.props.base.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
			                        </button>
		                        </div>
		                        {
		                        	this.props.defaultOptionState.signatureType === 'attached' && !this.props.defaultOptionState.showUpgradeCard
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-1 row no-left-no-right-padding" style={{"marginLeft": "0px", "marginRight": "0px"}}>
		                        		{
		                        			this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName)
		                        			? <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1"  style={{"paddingRight": "0px"}}><button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isPreviewEnabled} onClick={this.showPreviewPopupVerify}><i className="fa fa-eye"></i></button></div>
		                        			: null
		                        		}
		                        		<div className={this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName) ? "col-lg-11 col-md-11 col-sm-11 col-xs-11" : "col-lg-12 col-md-12 col-sm-12 col-xs-12"}><button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isEnabledDownload} onClick={this.downloadSignedData.bind(this)}>{i18next.t("ds:saveSignedData")}</button></div>
		                        	</div>
		                        	: null
		                        }
		                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-2 order-md-6 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
	                        </div>
	                        <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.downloadModifiedData.bind(this)}>{i18next.t("ds:downloadModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
		                    <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div style={{marginTop: "10px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.verifyModifiedData.bind(this)}>{i18next.t("ds:verifyModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
	                    </div>
	                    </div>
	                   </div>
	                   <VerifyTextDSContainer />
	                </div>
	                <div>
		                {
							this.props.base.showPreviewPopupVerify
							? <PreviewPopup file={this.props.defaultState.fileSignedData} />
							: null
						}
	                    {
	                        this.state.showPopup
	                        ? <QRPopup closeQRPopup={this.handleShowQR} data={this.state.displayedData} />
	                        : null
	                    }
	                    {
	                        this.state.showPrivateSignPopup
	                        ? <PrivateSignPopup closePrivateSignPopup={this.handleShowPrivateSign} data={this.state.displayedData} />
	                        : null
	                    }
	                </div>
	            </div>
	        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
    	base: state.base,
        language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        defaultState: state.verifyDSInputReducer,
        defaultOptionState: state.verifyDSOptionsReducer,
        mobileModeReducer: state.mobileModeReducer,
        expandedCardsReducer: state.expandedCardsReducer,
        upgradeReducer: state.upgradeDSReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setVerifyInputFile,
    	setVerifyDSInputFile,
    	clearVerifyInputFile,
    	clearVerifyDSInputFile,
    	clearVerifyResultData,
    	clearFileSignedData,
    	setVerifyDSExpand,
    	clearModifiedDSData,
    	setIsLoading,
    	setSignatureDifferenceType,
    	clearSignatureDifferenceType,
    	checkExtensionVerify, setShowPreviewPopupVerify,
    	fromBytes, setBodyIsMounted, setShowUpgradeCard
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDSTab);